var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 19H18C18.2652 19 18.5196 19.1054 18.7071 19.2929C18.8946 19.4804 19 19.7348 19 20C19 20.2652 18.8946 20.5196 18.7071 20.7071C18.5196 20.8946 18.2652 21 18 21H2C1.73478 21 1.48043 20.8946 1.29289 20.7071C1.10536 20.5196 1 20.2652 1 20C1 19.7348 1.10536 19.4804 1.29289 19.2929C1.48043 19.1054 1.73478 19 2 19ZM10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289C9.10536 1.48043 9 1.73478 9 2V13.586L6.707 11.293C6.61475 11.1975 6.50441 11.1213 6.3824 11.0689C6.2604 11.0165 6.12918 10.9889 5.9964 10.9877C5.86362 10.9866 5.73194 11.0119 5.60905 11.0622C5.48615 11.1125 5.3745 11.1867 5.2806 11.2806C5.18671 11.3745 5.11246 11.4861 5.06218 11.609C5.0119 11.7319 4.9866 11.8636 4.98775 11.9964C4.9889 12.1292 5.01649 12.2604 5.0689 12.3824C5.12131 12.5044 5.19749 12.6148 5.293 12.707L9.293 16.707C9.3861 16.7996 9.49653 16.873 9.618 16.923C9.73894 16.9738 9.86881 17 10 17C10.1312 17 10.2611 16.9738 10.382 16.923C10.5035 16.873 10.6139 16.7996 10.707 16.707L14.707 12.707C14.8892 12.5184 14.99 12.2658 14.9877 12.0036C14.9854 11.7414 14.8802 11.4906 14.6948 11.3052C14.5094 11.1198 14.2586 11.0146 13.9964 11.0123C13.7342 11.01 13.4816 11.1108 13.293 11.293L11 13.586V2C11 1.73478 10.8946 1.48043 10.7071 1.29289C10.5196 1.10536 10.2652 1 10 1Z",
    fill: "#292929",
    stroke: "#ECECEC",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.66ea6ed6b48e43cbac8923b70700e77d.svg";
export { ForwardRef as ReactComponent };